var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('SkeletonLoader', {
    class: _vm.isMobile ? _vm.$style.cardImageContainerMobile : _vm.$style.cardImageContainer
  }), _vm.hasCard ? _c('SkeletonLoader', {
    class: _vm.$style.appDescription
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }